import log from 'loglevel';
import { clearTokens, getToken, updateTokens } from './manageTokens.js';
import { normalizeTokens } from './normalizeTokens.js';
import { normalizeApiError } from '../errors/index.js';
import { getPublicRequest } from '../requests/getPublicRequest.js';
export async function refreshWithApi(client, refreshToken) {
    const path = `${client.context.api.host}/refresh`;
    try {
        const req = await getPublicRequest(client);
        const res = await req
            .post(path)
            .send({})
            .auth(refreshToken, { type: 'bearer' });
        return normalizeTokens(res.body);
    }
    catch (err) {
        throw normalizeApiError(err);
    }
}
export default async function refreshTokens(client, refreshProvider = refreshWithApi) {
    const refreshToken = getToken(client, 'refreshToken');
    if (!refreshToken)
        throw new Error('No refresh token');
    try {
        const tokens = await refreshProvider(client, refreshToken);
        updateTokens(client, tokens);
        return tokens.idToken;
    }
    catch (err) {
        const error = normalizeApiError(err);
        if (error.statusCode < 500) {
            log.info(`Received ${error.statusCode} while refreshing token, clearing tokens`);
            clearTokens(client);
        }
        throw error;
    }
}
